import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="flex items-center justify-center pt-32 md:pt-40 pb-16 md:pb-20">
      <div className="container-narrow text-center">
        <div className="max-w-3xl mx-auto">
          {/* Headline */}
          <h1 className="text-4xl md:text-5xl lg:text-[4rem] font-semibold leading-[1.1] text-balance fade-in-up text-foreground">
            Websites Built for Serious Real Estate Professionals
          </h1>

          {/* Subheadline */}
          <p className="mt-6 md:mt-8 text-lg md:text-xl text-soft leading-relaxed max-w-2xl mx-auto text-balance fade-in-up stagger-1">
            Site Elevation designs modern, independent websites that establish credibility, clarity, and authority — so your online presence reflects the level you operate at.
          </p>

          {/* CTA Section */}
          <div className="mt-10 md:mt-12 fade-in-up stagger-2">
            <Button variant="cta" size="lg" onClick={() => navigate("/website-review")}>
              Request a Website Review
            </Button>
            <p className="mt-3 text-sm text-muted-foreground">
              Free, honest review. No pitch.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
